import {
  INVOICE_SET_DATE,
  INVOICE_SET_CLINIC,
  INVOICE_SET_CLINICS,
  INVOICE_GET_PURCHASE_LOCATIONS,
  INVOICE_SET_PURCHASE_LOCATION,
  INVOICE_PRODUCTS_LOADING,
  INVOICE_GET_PRODUCTS,
  INVOICE_SET_RECEIPT_ERROR,
  INVOICE_UPDATE_LINE_ITEMS,
  INVOICE_IS_SUBMITTING,
  INVOICE_VERIFICATION_SUCCESS,
  INVOICE_UPDATE_PROMO_CODES,
  INVOICE_CLEAR,
  INVOICE_ERROR,
  INVOICE_SAVE_USER,
  INVOICE_SET_SUCCESS_MESSAGE,
  INVOICE_SET_TRANSACTION_ID,
  INVOICE_SET_RECEIPTS,
  INVOICE_SET_RECEIPTS_LOADING,
  INVOICE_SET_RECEIPT_TO_BE_REPLACED,
  INVOICE_REMOVE_RECEIPT,
} from '../constants/invoice';
import { GET_USER_SUCCESS } from '../constants/user';

export const initialState = {
  user: {},
  receipts: [],
  receiptToBeReplaced: null,
  transaction_id: null,
  items: [],
  availableClinics: [],
  availablePurchaseLocations: [],
  clinic: null,
  datePurchased: null,
  purchaseLocation: null,
  isFileUploading: false,
  isSubmitting: false,
  isVerifying: false,
  products: [],
  productsLoading: false,
  verification: {
    transactionPointValue: null, // items + promotion point value
    promotionPointValue: null, // just promotion point value
    availablePromotionCodes: [], // promotion codes available for line items
  },
  promoCodes: [], // promotion codes user is submitting with transaction
  error: null,
  errorMessage: null,
  showSuccessMessage: false,
};

export default function invoiceReducer(state = initialState, action = undefined) {
  if (action === undefined) {
    return state;
  }
  switch (action.type) {
    case INVOICE_SET_DATE:
      return {
        ...state,
        datePurchased: action.date,
      };

    case INVOICE_SET_CLINIC:
      return {
        ...state,
        clinic: action.clinic,
      };

    case INVOICE_SET_CLINICS:
      return {
        ...state,
        availableClinics: action.availableClinics,
      };

    case INVOICE_SET_TRANSACTION_ID:
      return {
        ...state,
        transaction_id: action.transaction_id,
      };

    case INVOICE_SET_RECEIPTS_LOADING:
      return {
        ...state,
        isFileUploading: true,
      };

    case INVOICE_SET_RECEIPTS:
      return {
        ...state,
        isFileUploading: false,
        receipts: state.receipts.concat(action.receipts),
      };

    case INVOICE_REMOVE_RECEIPT:
      return {
        ...state,
        receipts: state.receipts.filter((receipt) => receipt.id !== action.receipt.id),
      };

    case INVOICE_SET_RECEIPT_TO_BE_REPLACED:
      // in this case the user is trying to remove the last receipt, which is not allowed.
      // so we clear the receipts array and set the receiptToBeReplaced so that in can be replaced later
      return {
        ...state,
        receiptToBeReplaced: action.receipt,
        receipts: [],
      };

    case INVOICE_SET_RECEIPT_ERROR: {
      return {
        ...state,
        isFileUploading: false,
        file: null,
        transaction_id: null,
        error: action.error,
        errorMessage: action.message,
      };
    }

    case INVOICE_SET_PURCHASE_LOCATION: {
      return {
        ...state,
        purchaseLocation: action.purchaseLocation,
      };
    }

    case INVOICE_GET_PRODUCTS: {
      return {
        ...state,
        productsLoading: false,
        products: action.products,
      };
    }

    case INVOICE_PRODUCTS_LOADING: {
      return {
        ...state,
        productsLoading: true,
      };
    }

    case INVOICE_GET_PURCHASE_LOCATIONS: {
      return {
        ...state,
        availablePurchaseLocations: action.availablePurchaseLocations,
      };
    }

    case INVOICE_UPDATE_LINE_ITEMS: {
      return {
        ...state,
        items: action.items,
      };
    }

    case INVOICE_IS_SUBMITTING: {
      return {
        ...state,
        isSubmitting: !action.verify,
        isVerifying: action.verify,
        error: null,
        errorMessage: null,
      };
    }

    case INVOICE_VERIFICATION_SUCCESS: {
      return {
        ...state,
        verification: {
          ...action.verification,
        },
        error: null,
        errorMessage: null,
        isVerifying: false,
      };
    }

    case INVOICE_CLEAR: {
      // clear only invoice specific data when submitted. Products, available purchase locations and available clinics should remain in store.
      // showSuccessMessage shouldn't get cleared so it can display for a few seconds before unsetting
      const products = state.products;
      const availablePurchaseLocations = state.availablePurchaseLocations;
      const availableClinics = state.availableClinics;
      const showSuccessMessage = state.showSuccessMessage;

      return {
        ...initialState,
        products,
        availableClinics,
        availablePurchaseLocations,
        showSuccessMessage,
        user: action.clearUser ? {} : state.user,
      };
    }

    // clear the store when the user changes
    case GET_USER_SUCCESS: {
      const products = state.products;
      const availablePurchaseLocations = state.availablePurchaseLocations;
      return {
        ...initialState,
        products,
        availablePurchaseLocations,
      };
    }

    case INVOICE_UPDATE_PROMO_CODES: {
      return {
        ...state,
        promoCodes: action.promoCodes,
      };
    }

    case INVOICE_ERROR: {
      const is_invalid_products_error = action.message?.includes('products added is not valid');
      const items = is_invalid_products_error ? [] : state.items;
      return {
        ...state,
        isSubmitting: false,
        isVerifying: false,
        error: action.error,
        errorMessage: action.message,
        items,
      };
    }

    case INVOICE_SAVE_USER: {
      return {
        ...state,
        user: action.user,
      };
    }

    case INVOICE_SET_SUCCESS_MESSAGE: {
      return {
        ...state,
        showSuccessMessage: action.showSuccessMessage,
      };
    }

    default:
      return state;
  }
}
